import { useNavigate } from "react-router-dom";
import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";

const ServingPromptModal = (props) => {
  const { openModal, URL, setOpenModal, profile } = props;
  const navigate = useNavigate();
  const { _t } = useTranslator();

  const onClose = () => {
    setOpenModal(false);
  };

  return (
    openModal && (
      <Modal
        show={openModal}
        onHide={onClose}
        centered
        className="newmodalui max-w-lg tailwind-base-modal wrapper-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_t(
              "viewProfileLLHeaderForSelfServingTool",
              "Title for popup for self serving tool when LL tries to open a profile and deduction is needed."
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {profile?.tenantid?.email == "demotenant@skortorent.com" ? (
            <p className="text-center">
              {_t(
                "thisIsADemoProfileNormallyItCosts",
                "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
              )}{" "}
              <span className="fw-bold text-decoration-underline">
                {_t(
                  "5Credits",
                  "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                )}
              </span>{" "}
              {_t(
                "toViewANewProfileButThisOneIsFreeSoYouCanTryOutHowTHeInformationLooks",
                "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
              )}
            </p>
          ) : (
            <>
              <p className="text-center">
                {_t(
                  "youWillSpend",
                  "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                )}{" "}
                <span className="fw-bold text-decoration-underline">
                  {_t(
                    "5Credits",
                    "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                  )}
                </span>{" "}
                {_t(
                  "toOpenThisProfileForTheFirstTime",
                  "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                )}
              </p>
              <p className="text-center">
                {_t(
                  "reopeningItLaterIsFreeThisOnlyAppliesToNewProfilesNotOnesYouHaveAlreadyViewed",
                  "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                )}
              </p>
            </>
          )}
        </Modal.Body>
        <div className="inviteButtonWrapper">
          <button
            type="button"
            onClick={onClose}
            className="btnNext btnnextpre mr-2"
          >
            {_t("goBack")}
          </button>
          <button
            type="button"
            onClick={() => {
              navigate(URL);
            }}
            className="btnNext basicInfoButton greenHover"
          >
            {_t("continue")}
          </button>
        </div>
      </Modal>
    )
  );
};

export default ServingPromptModal;
